import React, { useState } from 'react';

import { useToggle } from 'react-use';
import { observer } from 'mobx-react';
import { Button } from '@infoods/lifebase-ui';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

import classes from './PaymentActionRow.module.scss';
import { currentSubscriptionPlanStore } from '../../../../../stores/currentSubscriptionPlanStore';
import { UpdateCardModal } from '../../UpdateCardModal/UpdateCardModal';
import { getUpdateCardUnavailableReason } from './utils/getUpdateCardUnavailableReason';

type PaymentActionRowProps = {
  customerId: number;
  entityId: number;
};

const PaymentActionRow = observer(({ customerId, entityId }: PaymentActionRowProps) => {
  const [isShowUpdateCardModal, toggleShowUpdateCardModal] = useToggle(false);
  const [isAlreadyRetry, setIsAlreadyRetry] = useState(false);

  const {
    currentSubscriptionPlan,
    paymentStatusFlag,
    retryPayment,
    subscriptionTypeFlags,
  } = currentSubscriptionPlanStore;

  if (!currentSubscriptionPlan) {
    return null;
  }

  const { subscription } = currentSubscriptionPlan;

  const handleRetryPayment = async () => {
    await retryPayment();
    setIsAlreadyRetry(true);
  };

  const updateCardUnavailableReason = getUpdateCardUnavailableReason(
    !!subscription,
    subscriptionTypeFlags,
  );

  return (
    <>
      <div className={classes.actionRow}>
        <Button
          className={classes.actionButton}
          variant="outlined"
          size="small"
          onClick={toggleShowUpdateCardModal}
          disabled={!!updateCardUnavailableReason}
        >
          Update Card
        </Button>
        {paymentStatusFlag.PAYMENT_ISSUE && (
          <Button
            className={classes.actionButton}
            variant="outlined"
            size="small"
            startIcon={isAlreadyRetry ? <CheckRoundedIcon /> : <RefreshRoundedIcon />}
            onClick={handleRetryPayment}
            disabled={isAlreadyRetry}
          >
            Retry payment
          </Button>
        )}
        {!!updateCardUnavailableReason && <p>{updateCardUnavailableReason}</p>}
      </div>
      {isShowUpdateCardModal && (
        <UpdateCardModal
          customerId={customerId}
          entityId={entityId}
          onClose={toggleShowUpdateCardModal}
        />
      )}
    </>
  );
});

export { PaymentActionRow };
